import React from 'react';
import {Button } from 'antd';

const objeto = () => {

const dataIni = {
    key:"1",
    name:"pepe"
}

//const [data, setData] = useState(dataIni)

function Add () {
    console.log(dataIni)
  // console.log(data)
}

    return (
        <div>
            <Button onClick={Add}>add data</Button>
        </div>
    )
}

export default objeto